const EURO = 'Euro';
const IHHF = 'Ihhf';
const FIFA = 'Fifa';

export const TREND_THEMES = {
  EURO,
  IHHF,
  FIFA
};
